const TILES = ["bg-ink", "bg-marigold", "border-2 border-ink", "bg-rose", "eight", "bg-marigold", "border-2 border-ink", "bg-marigold", "bg-ink"];

export const Book = () => (
  <section id="book" className="bg-sand text-ink py-24 md:py-32" data-testid="book-section">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
      <div className="fr-stack fr-reveal" aria-hidden="true">
        <div className="grid grid-cols-3 gap-2 max-w-md">
          {TILES.map((t, i) =>
            t === "eight" ? (
              <span key={i} className="aspect-square bg-ink font-mono text-marigold flex items-center justify-center text-3xl">8</span>
            ) : (
              <span key={i} className={`aspect-square ${t}`} />
            )
          )}
        </div>
        <p className="font-mono fr-lbl mt-10" data-testid="book-eight-caption">8 children / 2 mothers / 1 roof</p>
      </div>
      <div className="min-w-0 fr-reveal">
        <p className="font-mono fr-lbl">The book</p>
        <h2 className="font-mono font-bold mt-4 fr-h2" data-testid="book-differentiator">
          The structure has changed. The commitment to not doing family alone has not.
        </h2>
        <p className="mt-6 text-[17px] leading-[1.6] max-w-[60ch]" data-testid="book-description">
          A narrative and practical exploration of family as a living practice: how people raise children across bloodlines, households, partnerships, and changing structures without making any one arrangement the universal answer.
        </p>
        <p className="mt-4 text-[17px] leading-[1.6] max-w-[60ch]">
          It asks what we have been taught to call family, why some relationships are automatically ranked above others, what shared care demands of adults, and what children learn when belonging is not organized entirely through scarcity, ownership, and one household.
        </p>
      </div>
    </div>
  </section>
);
